import Vue from 'vue'
import Vuex from 'vuex'
import apiRequest from '@/apiRequest'
import Notifications from '@/store/notifications/notifications'

Vue.use(Vuex)

interface ProductsFromCatalogInterface {
  catalogId: string | null,
  sortBy: {
    fieldName: string,
    orderBy: 'asc' | 'desc'
  },
  searchQuery: string,
  page: number,
  perPage: number,
  totalProducts: number
  productsList: object | null,
}

export default new Vuex.Store({
  state: (): ProductsFromCatalogInterface => (
    {
      catalogId: null,
      sortBy: {
        fieldName: 'id',
        orderBy: 'asc',
      },
      searchQuery: '',
      page: 1,
      perPage: 60,
      totalProducts: 0,
      productsList: null,
    }
  ),
  mutations: {
    setCatalogId: (state: any, catalogId: string) => {
      state.catalogId = catalogId
    },
    setPage: (state: any, page:number) => {
      state.page = page
    },
    setSortBy: (state: any, sort: { field: string, order: string }) => {
      state.sortBy = {
        fieldName: sort.field,
        orderBy: sort.order,
      }
    },
    setSortByDirection: (state: any, order: string) => {
      state.sortBy.orderBy = order
    },
    setSortByField: (state: any, fieldName: string) => {
      state.sortBy.fieldName = fieldName
    },
    setProductsListAndTotal: (state: any, response: {totalCount: number, products: any}) => {
      state.productsList = response.products
      state.totalProducts = response.totalCount
    },
    setQuery: (state: any, query: string) => {
      state.searchQuery = query
    },
  },
  actions: {
    getProductsFromCatalog(context: any) {
      const pageToUrl: string = context.state.page.toString()
      const perPageToUrl: string = context.state.perPage.toString()

      const pageUrlParams: string = `page=${pageToUrl}&perPage=${perPageToUrl}`
      const sortUrlParams: string = `sortBy=${context.state.sortBy.fieldName}&sortOrder=${context.state.sortBy.orderBy}`
      const queryUrlParams: string = `query=${context.state.searchQuery}`

      return context.dispatch('fetchProductsListFromCatalog', `catalog/${context.state.catalogId}/products?${pageUrlParams}&${sortUrlParams}&${queryUrlParams}`)
    },
    fetchProductsListFromCatalog(context: any, url: string) {
      return apiRequest
        .get(url)
        .then(result => {
          if (result.status === 200) {
            context.commit('setProductsListAndTotal', result.data)
          }
          return result
        })
        .catch(error => {
          Notifications.commit('addError', error, {root: true})
        })
    },
  },
})
